import {inject} from "@angular/core";
import {CanActivateFn, Router} from "@angular/router";
import {filter, map, take} from "rxjs";
import {UserEnum} from "@knust/api-interfaces";
import {AuthService} from "../services/auth.service";
import {AuthStatus} from "../enums/auth-status";

/**
 * Erlaubt eine Route nur für die angegebenen Benutzerrollen (entspricht der Menü-Logik in core.component.html).
 * Ohne Berechtigung wird auf die Artikelübersicht umgeleitet, ohne Login auf die Login-Seite.
 * Es wird gewartet, bis der Anmeldestatus feststeht, damit ein aus dem sessionStorage
 * wiederhergestellter Benutzer nicht fälschlich umgeleitet wird.
 */
export function roleGuard(...roles: UserEnum[]): CanActivateFn {
  return (_route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.currentStatus.pipe(
      filter(status => status !== AuthStatus.PENDING),
      take(1),
      map(status => {
        if (status !== AuthStatus.LOGGED_IN) {
          return router.parseUrl('/login?prev=' + state.url);
        }

        const userType = authService.currentUser.value?.type;
        return roles.includes(userType) ? true : router.parseUrl('/artikel');
      }),
    );
  };
}
